import { Injectable } from '@angular/core';
import { environment } from '../../environment/environment';
import { BehaviorSubject, combineLatest, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EclipseHeaderService {

  rootUrl: string = environment.rootUrl;
  readonly #clientName: BehaviorSubject<string> = new BehaviorSubject<string>('');
  readonly #clientNumber: BehaviorSubject<string> = new BehaviorSubject<string>('');
  readonly #watchlistId: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  readonly #showHeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  readonly #isWatchlistAuditHistoryMenuVisible: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  clientName$ = this.#clientName.asObservable();
  clientNumber$ = this.#clientNumber.asObservable();
  watchlistId$ = this.#watchlistId.asObservable();
  isWatchlistAuditHistoryMenuVisible$ = this.#isWatchlistAuditHistoryMenuVisible.asObservable();
  showHeader$ = this.#showHeader.asObservable();
  private topPosition: number = 0;

  constructor() { }

  setEclipseHeaderVisiblity(show: boolean) {
    this.#showHeader.next(show);
  }

  showWatchlistAuditHistoryMenu(show: boolean): void {
    this.#isWatchlistAuditHistoryMenuVisible.next(show);
  }

  navigateWatchlistAuditTrial(clientNumber?: string, watchlistId?: number | undefined, clientName?: string) {
    if (watchlistId == undefined) {
      combineLatest([
        this.clientName$,
        this.clientNumber$,
        this.watchlistId$
      ]).pipe(take(1))
        .subscribe(
          ([
            clientName,
            clientNumber,
            watchlistId
          ]) => {
            const url = this.rootUrl + 'watchlist/audit-trail/watchlistId/' + watchlistId;

            const newTab = window.open(url, '_blank');
            if (newTab) {
              newTab.onload = () => {
                newTab.history.replaceState({ clientNumber, clientName }, '');
                newTab.addEventListener('scroll', (event) => {
                });
              };
            }
          });
    } else {
      const url = this.rootUrl + 'watchlist/audit-trail/watchlistId/' + watchlistId;
      const newTab = window.open(url, '_blank');
      if (newTab) {
        newTab.onload = () => {
          newTab.history.replaceState({ clientNumber, clientName }, '');
          newTab.addEventListener('scroll', (event) => {
          });
        };
      }
    }
  }

  setWatchlistAuditParams(clientName: string, clientNumber: string, watchlistId: number): void {
    this.#clientName.next(clientName);
    this.#clientNumber.next(clientNumber);
    this.#watchlistId.next(watchlistId);
  }

  getHeaderHeight(showHeader: boolean): void {
    let headerHeight: number = 0;
    const headerContainer: number =
      (document.querySelector('.header-custom-container') as HTMLElement)
        ?.offsetHeight ?? 0;

    if (!showHeader) {
      headerHeight = headerContainer;
    }
    if (this.topPosition != headerHeight) {
      this.topPosition = headerHeight;
      this.updateStickyTopPositionInCSS();
    }
  }

  updateStickyTopPositionInCSS(): void {
    const styleId = 'sticky-element-after-black-header';
    let styleElement = document.getElementById(styleId) as HTMLStyleElement;

    // If the style element doesn't exist, create it
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    // Update the CSS rule for the class
    styleElement.innerHTML = `
      .sticky-element-after-black-header {
        top: ${this.topPosition}px !important;
      }
    `;
  }

  scrollToTop(): void {
    window.scrollTo({ top: this.topPosition, behavior: 'smooth' });
  }
}
